module.exports = __webpack_public_path__ + "images/job/detail/detail_icon04-8975e0f6f9a4aebacbed5e7bb0f0e008.png";